"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectHelper = void 0;
const tslib_1 = require("tslib");
const Error_1 = require("../shared/Error");
class RedirectHelper {
    static appendQueryParamToURL(urlString, paramKey, paramValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const url = new URL(urlString);
                url.searchParams.append(paramKey, paramValue);
                return url.toString();
            }
            catch (error) {
                return Promise.reject(Error_1.CustomerAuthnError.INVALID_REDIRECT_URL);
            }
        });
    }
}
exports.RedirectHelper = RedirectHelper;
//# sourceMappingURL=RedirectHelper.js.map